import React from 'react';
import './FinancasWaitingBadge.css';
import { FinancasWaitingData } from './types';

interface Props {
  waiting?: FinancasWaitingData | null;
}

export const hasNewFromFinancas = (waiting?: FinancasWaitingData | null): boolean =>
  (waiting?.new_messages ?? 0) > 0;

/**
 * Marks a case where Finanças wrote something this lawyer has not seen.
 *
 * The e-balcão reader opens every request each morning, which marks it read in
 * the Portal das Finanças, so the portal no longer shows her which requests
 * have news. This does, for any message: an answer, an approval, a question.
 * It clears once she opens the case page.
 */
const FinancasNewBadge: React.FC<Props> = ({ waiting }) => {
  if (!hasNewFromFinancas(waiting)) {
    return null;
  }
  const count = waiting?.new_messages ?? 0;
  return (
    <span
      className="case-financas-new-badge"
      data-testid="case-financas-new-badge"
      title={`${count} new ${count === 1 ? 'message' : 'messages'} from Finanças`}
    >
      New from Finanças
    </span>
  );
};

export default FinancasNewBadge;
